import { FilterableTableInvoices } from "../../../components/TableInvoices/FilterableTableInvoices";
import {
  INVOICE_STATUSES_DEPOSITED,
  INVOICE_STATUSES_REFUNDED
} from "../../../types";

export const RouteDeposited: React.FC = () => (
  <FilterableTableInvoices
    statuses={[...INVOICE_STATUSES_DEPOSITED, ...INVOICE_STATUSES_REFUNDED]}
    showDownloadCsv
    emptyState={{ standart: "No deposited invoices." }}
  />
);
